const baseVariantShared = {
  alignItems: 'center',
  textAlign: 'center'
};

export const headingStyles = {
  default: { ...baseVariantShared },
  leftAlign: { ...baseVariantShared },
  darkBackground: { ...baseVariantShared }
};

const co = {
  default: {
    ...baseVariantShared
  },
  leftAlign: {
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  darkBackground: {
    ...baseVariantShared,
    '*, .featureGridSectionTitle, p': {
      color: 'coolGrey.0'
    }
  }
};

const heading = {
  products: {
    chart: headingStyles,
    chartblog: headingStyles,
    co,
    edu: headingStyles,
    scale: headingStyles,
    spark: headingStyles
  }
};

export default heading;
